// 这里要注意不要在mutations里面进行异步操作，只是用来改变state的值
import * as TYPES from './mutation-types'
import Vue from 'vue'
import {setToken} from '../../utils/authc'

export default {
  [TYPES.ADD_CURRENT_USER] (state, payload) {
    Vue.set(state, 'currentUser', payload)
  },

  [TYPES.ADD_USER_LOGIN_INFO] (state, payload) {
    setToken(payload.accessToken)
  },

  [TYPES.ADD_ASYNC_ROUTERS] (state, payload) {
    Vue.set(state, 'asyncRouters', payload)
  },

  [TYPES.ADD_ALL_PERMISSION_LIST] (state, payload) {
    Vue.set(state, 'allPermissionList', payload)
  },

  [TYPES.ADD_ORDER_DETAIL_DATAS] (state, payload) {
    Vue.set(state, 'orderDetailInfo', payload)
  },

  [TYPES.ADD_SYS_ROLE_LIST] (state, payload) {
    Vue.set(state, 'sysRoleList', payload)
  },

  [TYPES.ADD_USER_STATUS_DIC_LIST] (state, payload) {
    Vue.set(state, 'userStatusDicList', payload)
  },

  [TYPES.ADD_USER_BASE_INFO] (state, payload) {
    Vue.set(state, 'userBaseInfo', payload)
  },

  [TYPES.CLEAR_USER_BASE_INFO] (state, payload) {
    Vue.set(state, 'userBaseInfo', null)
  },

  [TYPES.EDIT_ADMIN_REGISTER_STEP] (state, payload) {
    // 重置注册信息
    if (payload === -1) {
      Vue.set(state, 'registerUserInfo', {})
    }
    Vue.set(state, 'registerStep', payload)
  },

  [TYPES.ADD_ADMIN_REGISTER_USER_INFO] (state, payload) {
    let oldInfo = state.registerUserInfo
    if (oldInfo === undefined) {
      oldInfo = {}
    }
    // 合并对象
    let newInfo = Object.assign(oldInfo, payload)
    Vue.set(state, 'registerUserInfo', newInfo)
  },

  [TYPES.ADD_COMPANY_NAME_ID_LIST] (state, payload) {
    Vue.set(state, 'companyNameIdList', payload)
  },

  [TYPES.ADD_HOSPITAL_NAME_ID_LIST] (state, payload) {
    Vue.set(state, 'hospitalNameIdList', payload)
  },

  [TYPES.ADD_DOCTOR_DEGREE_DIC_LIST] (state, payload) {
    Vue.set(state, 'doctorDegreeDicList', payload)
  },

  [TYPES.ADD_DOCTOR_TITLE_DIC_LIST] (state, payload) {
    Vue.set(state, 'doctorTitleDicList', payload)
  },

  [TYPES.ADD_HOSPITAL_DEGREE_DIC_LIST] (state, payload) {
    Vue.set(state, 'hospitalDegreeDicList', payload)
  },

  [TYPES.ADD_POINT_STATUS] (state, payload) {
    Vue.set(state, 'pointStatusList', payload)
  },

  [TYPES.ADD_POINT_HANDLE_TYPE] (state, payload) {
    Vue.set(state, 'pointHandleTypeList', payload)
  },

  [TYPES.ADD_HOSPITAL_STATUS_LIST] (state, payload) {
    Vue.set(state, 'hospitalStatusDicList', payload)
  },

  [TYPES.ADD_WITHDRAW_STATUS_DIC_LIST] (state, payload) {
    Vue.set(state, 'withdrawStatusDicList', payload)
  },

  [TYPES.ADD_AUDIT_WITHDRAW_ID] (state, payload) {
    Vue.set(state, 'auditWithdrawId', payload)
  },

  [TYPES.ADD_DOCTOR_STATUS_LIST] (state, payload) {
    Vue.set(state, 'doctorStatusDicList', payload)
  },

  [TYPES.ADD_ORDER_STATUS_LIST] (state, payload) {
    Vue.set(state, 'orderStatusDicList', payload)
  },

  [TYPES.ADD_ORDER_PATHOLOGY_TYPE_LIST] (state, payload) {
    Vue.set(state, 'orderPathologyTypeDicList', payload)
  },

  [TYPES.ADD_ESOPHAGUS_STATUS_DIC_LIST] (state, payload) {
    Vue.set(state, 'esophagusStatusDicList', payload)
  },

  [TYPES.ADD_ESOPHAGUS_FROM_DIC_LIST] (state, payload) {
    Vue.set(state, 'esophagusFromDicList', payload)
  },

  [TYPES.ADD_EPS_SN_STATUS_DIC_LIST] (state, payload) {
    Vue.set(state, 'epsSNStatusDicList', payload)
  },

  [TYPES.ADD_LAB_NAME_ID_LIST] (state, payload) {
    Vue.set(state, 'laboratoryIdNameIdList', payload)
  },

  [TYPES.ADD_EXPRESS_PAY_METHOD_DIC_LIST] (state, payload) {
    Vue.set(state, 'expressPayMethodDicList', payload)
  },

  [TYPES.ADD_EXPRESS_DIC_LIST] (state, payload) {
    Vue.set(state, 'expressListDicList', payload)
  },

  [TYPES.ADD_RECEIVING_TYPE_DIC_LIST] (state, payload) {
    Vue.set(state, 'receivingTypeListDicList', payload)
  },

  [TYPES.ADD_RECORD_TYPE_DIC_LIST] (state, payload) {
    Vue.set(state, 'recordTypeList', payload)
  },

  [TYPES.ADD_AGENT_LIST] (state, payload) {
    Vue.set(state, 'agentList', payload)
  },

  [TYPES.ADD_WECHAT_MENU_URL] (state, payload) {
    Vue.set(state, 'wechatMenuList', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/mutations.js